import CopyIcon from '@assets/icons/copy.svg';
import DetailsIcon from '@assets/icons/eye.svg';

export const DROPDOWN_VALUES = {
  SHARE: 'Copy link',
  DETAILS: 'Details',
};

export const DROPDOWN_ITEMS = [
  {
    value: DROPDOWN_VALUES.SHARE,
    icon: <CopyIcon />,
    disabled: false,
  },
  {
    value: DROPDOWN_VALUES.DETAILS,
    icon: <DetailsIcon />,
    disabled: false,
  },
];
